import { ComponentType } from 'react'

import { FieldProps, FormConfig, FormInputProps } from 'brief-form'

import { CompanyForm, CompanyManage } from '../../../../../../typings'

export type ManageCompanyFormProps = {
  Field: <Input extends ComponentType<FormInputProps<any, any>>>(
    props: FieldProps<Input, CompanyForm, unknown>
  ) => JSX.Element
  config: FormConfig<CompanyForm>
  companyForDelete: {
    id: number | null
    name: string | null
  } | null
  companyData: CompanyManage
  isSubmitting: boolean
  isDirty: boolean
}
